/**
 * Utility to find the active menu keys (selected and open) for a given URL path.
 * Used primarily for syncing navigation menus (like Sidebars) with the current route.
 */

import type { AppRoute } from '../../types/global.types';

export const findMenuKeys = (
  routes: AppRoute[],
  path: string,
): { selectedKey: string; openKeys: string[] } => {
  for (const route of routes) {
    // Exact or startsWith match for the current path
    if (path === route.path || path.startsWith(route.path + '/')) {
      if (!route.children) {
        return { selectedKey: route.path, openKeys: [] };
      }

      // Recursively find inside children
      const childResult = findMenuKeys(route.children, path);
      if (childResult.selectedKey) {
        return {
          selectedKey: childResult.selectedKey,
          openKeys: [route.path, ...childResult.openKeys],
        };
      }

      return { selectedKey: route.path, openKeys: [] };
    }

    // Recurse for deeper nested routes
    if (route.children) {
      const childResult = findMenuKeys(route.children, path);
      if (childResult.selectedKey) {
        return {
          selectedKey: childResult.selectedKey,
          openKeys: [route.path, ...childResult.openKeys],
        };
      }
    }
  }

  return { selectedKey: '', openKeys: [] };
};
